import './App.scss';
import NavBar from './Components/NavBar';
import ErrorBoundary from './Components/ErrorBoundary';
import { Switch, Route } from 'react-router-dom';
import { useState, Suspense, lazy } from 'react';

// Lazy-loaded pages for route-level code splitting
const HomePage      = lazy(() => import('./Pages/HomePage'));
const AboutPage     = lazy(() => import('./Pages/AboutPage'));
const PortfliosPage = lazy(() => import('./Pages/PortfoliosPage'));
const EducationPage = lazy(() => import('./Pages/EducationPage'));
const ExperiencePage = lazy(() => import('./Pages/ExperiencePage'));
const ContactPage   = lazy(() => import('./Pages/ContactPage'));

function PageLoader() {
  return (
    <div className="page-loader">
      <div className="loader-ring" />
    </div>
  );
}

function App() {
  const [navToggle, setNavToggle] = useState(false);
  const [theme, setTheme] = useState('dark');

  const navClick = () => setNavToggle((v) => !v);
  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  return (
    <div className="App" data-theme={theme}>
      <div className={`sidebar ${navToggle ? 'nav-toggle' : ''}`}>
        <NavBar theme={theme} toggleTheme={toggleTheme} />
      </div>

      {navToggle && <div className="nav-overlay" onClick={navClick} />}

      <div className="nav-btn" onClick={navClick} aria-label="Toggle menu">
        <div className="lines-1" />
        <div className="lines-2" />
        <div className="lines-3" />
      </div>

      <div className="main-content">
        <div className="content">
          <ErrorBoundary>
            <Suspense fallback={<PageLoader />}>
              <Switch>
                <Route path="/" exact component={HomePage} />
                <Route path="/about" exact component={AboutPage} />
                <Route path="/portfolios" exact component={PortfliosPage} />
                <Route path="/education" exact component={EducationPage} />
                <Route path="/experience" exact component={ExperiencePage} />
                <Route path="/contact" exact component={ContactPage} />
              </Switch>
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}

export default App;
